import { EditOutlined } from '@ant-design/icons';
import { type RelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { Button, List, Tooltip, Typography } from 'antd';
import { type IMapIntersectionLayer } from '../layers/getIntersectionLayersInfo.ts';
import { type IMapLayer } from '../layers/MapLayer.ts';

export interface IMapIntersectionsConfigSectionProps {
  layersEditor: RelationEditor<IMapLayer>;
  /** Layer con intersezione visibile, già filtrati per feature flag. */
  intersectionLayers: IMapIntersectionLayer[];
}

/**
 * Sezione nel configuratore widget mappa che mostra l'elenco
 * delle intersezioni configurate per-layer.
 */
export function MapIntersectionsConfigSection(
  props: IMapIntersectionsConfigSectionProps,
) {
  const { layersEditor, intersectionLayers } = props;

  return (
    <div>
      <Typography.Paragraph>
        Elenco dei livelli con intersezione abilitata. Per modificare
        un&apos;intersezione, apri la configurazione del livello corrispondente.
      </Typography.Paragraph>

      <List
        size="small"
        dataSource={intersectionLayers}
        locale={{ emptyText: 'Nessuna intersezione configurata' }}
        renderItem={layer => {
          const intersection = layer.intersection;

          return (
            <List.Item
              actions={[
                <Tooltip title="Modifica" key="edit">
                  <Button
                    size="small"
                    type="text"
                    aria-label="Modifica intersezione"
                    icon={<EditOutlined aria-hidden />}
                    onClick={e => {
                      e.stopPropagation();
                      layersEditor.handle.open(layer);
                    }}
                  />
                </Tooltip>,
              ]}
            >
              <List.Item.Meta
                title={intersection.title || layer.name}
                description={`Layer: ${layer.name} — ${intersection.attributes?.length ?? 0} ${intersection.attributes?.length === 1 ? 'attributo' : 'attributi'}`}
              />
            </List.Item>
          );
        }}
      />
    </div>
  );
}
